export const cancel_exchange_order = `mutation cancel_exchange_order($id: Int!){
    cancel_exchange_order(id: $id)
}`;
